module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ko":{"title":"리뷰 작성을 완료했습니다.","subtitle":"소중한 후기를 남겨주셔서 감사합니다.","reward":"{0} 적립 예정","my_reviews_button":"내가 작성한 리뷰 보러가기"}}')
  delete Component.options._Ctor
}
